import { environment } from "environments/environment";
import { ThemeTypes } from "app/core/theme/theme-types";

export enum KeycloakWhiteLabelClient {
  NconnectVoice = "nconnect-voice",
  O2SIPTrunk = "o2-business-teams-telefonie",
}

const getClientId = (client: string): string => {
  let keycloakClient = KeycloakWhiteLabelClient[client];

  if (window.location.origin.includes("-preview") && environment.production) {
    keycloakClient = `${keycloakClient}-preview`;
  }

  return keycloakClient;
};

export const KeycloakConfigMap: Record<
  ThemeTypes,
  {
    url: string;
    realm: string;
    clientId: string;
  }
> = {
  [ThemeTypes.NconnectVoiceTheme]: {
    url: environment.keycloakConfig.url,
    realm: environment.keycloakConfig.realm,
    clientId: getClientId("NconnectVoice"),
  },
  [ThemeTypes.O2SIPTrunkTheme]: {
    url: environment.keycloakConfig.url,
    realm: environment.keycloakConfig.realm,
    clientId: getClientId("O2SIPTrunk"),
  },
};
